import { ArrowsExpandIcon } from "@heroicons/react/outline";
import React, { useEffect, useLayoutEffect, useState } from "react";
import Chat from "./Chat";
import Controls from "./Controls";
import RoundedIconButton from "./dumb-components/RoundedIconButton";
import { Invite } from "./Invite";
import OnlineUsers from "./OnlineUsers";
import Settings from "./Settings";
import VideoLayoutGrid from "./VideoLayoutGrid";

function CallLayout(props) {
  const ownerOnlyBroadcast = props.ownerOnlyBroadcast;
  const isAdmin = props.isAdmin;
  const showInviteBox = props.showInviteBox;
  const disabledChat = props.disabledChat;
  const chatRoomURL = props.chatRoomURL;
  const videoMode = props.videoMode;
  const sidebarPosition = props.sidebarPosition; // right or left
  const userInfo = props.userInfo;
  const meeting = props.meeting;
  const localMediaStream = props.localMediaStream;
  const cameraMuted = props.cameraMuted;
  const micMuted = props.micMuted;
  const screenShared = props.screenShared;
  const handRaised = props.handRaise;
  const chatVisible = props.chatVisible;
  const onlineUsersVisible = props.onlineUsersVisible;
  const sidebarVisible = props.sidebarVisible;
  const settingsVisible = props.settingsVisible;

  const activeSpeakerId = props.activeSpeakerId;

  const disableAudio = props.disableAudio;
  const disableVideo = props.disableVideo;
  const disableScreenSharing = props.disableScreenSharing;

  const handleCameraButtonClicked = props.handleCameraButtonClicked;
  const handleMicButtonClicked = props.handleMicButtonClicked;
  const handleScreenShareButtonClicked = props.handleScreenShareButtonClicked;
  const handleHandRaisedButtonClicked = props.handleHandRaisedButtonClicked;
  const handleChatButtonClicked = props.handleChatButtonClicked;
  const handleOnlineUsersButtonClicked = props.handleOnlineUsersButtonClicked;
  const handleEndCallButtonClicked = props.handleEndCallButtonClicked;
  const handleSettingsButtonClicked = props.handleSettingsButtonClicked;

  const handleCameraChanged = props.handleCameraChanged;
  const handleMicChanged = props.handleMicChanged;
  const handleSpeakerChanged = props.handleSpeakerChanged;

  const handleMuteUserAudio = props.handleMuteUserAudio;
  const handleMuteUserVideo = props.handleMuteUserVideo;
  const handleBanUser = props.handleBanUser;
  const handleEjectUser = props.handleEjectUser;
  const handleAcceptRequestToJoin = props.handleAcceptRequestToJoin;

  const onlineUsers = props.onlineUsers;
  const meetingAccessRequests = props.meetingAccessRequests;

  const [videoTiles, setVideoTiles] = useState([]);

  useLayoutEffect(() => {
    setVideoTiles(props.videoTiles);
  }, [props.videoTiles]);

  const ControlWithArguments = (() => {
    const controls = (
      <Controls
        disabledChat={disabledChat}
        cameraMuted={cameraMuted}
        micMuted={micMuted}
        screenShared={screenShared}
        handRaised={handRaised}
        chatVisible={chatVisible}
        onlineUsersVisible={onlineUsersVisible}
        sidebarVisible={sidebarVisible}
        settingsVisible={settingsVisible}
        disableAudio={disableAudio}
        disableVideo={disableVideo}
        meetingAccessRequests={meetingAccessRequests}
        disableScreenSharing={disableScreenSharing}
        handleCameraButtonClicked={handleCameraButtonClicked}
        handleMicButtonClicked={handleMicButtonClicked}
        handleScreenShareButtonClicked={handleScreenShareButtonClicked}
        handleHandRaisedButtonClicked={handleHandRaisedButtonClicked}
        handleChatButtonClicked={handleChatButtonClicked}
        handleOnlineUsersButtonClicked={handleOnlineUsersButtonClicked}
        handleEndCallButtonClicked={handleEndCallButtonClicked}
        handleSettingsButtonClicked={handleSettingsButtonClicked}
      />
    );

    if (ownerOnlyBroadcast) {
      if (isAdmin || !disableAudio || !disableVideo || !disableScreenSharing) {
        return controls;
      } else {
        return <></>;
      }
    } else {
      return controls;
    }
  })();

  if (props.sidebarVisible) {
    if (sidebarPosition === "right") {
      // Chat inside the sidebar
      return (
        <div className="grid md:grid-rows-1 grid-rows-2 grid-cols-1 sm:grid-cols-4 h-full w-full bg-gray-200 relative">
          <div className="md:col-span-3 sm:col-span-2  relative">
            {/* Main Area */}
            <VideoLayoutGrid
              ownerOnlyBroadcast={ownerOnlyBroadcast}
              meeting={meeting}
              localMediaStream={localMediaStream}
              onlineUsers={onlineUsers}
              videoTiles={videoTiles}
              activeSpeakerId={activeSpeakerId}
              mockVideoTags={4}
            />
            {ControlWithArguments}
          </div>

          <div className="bg-red-400 md:col-span-1 sm:col-span-2 relative">
            {/* Sidebar */}
            <RoundedIconButton
              className="sm:hidden absolute right-0 top-0"
              icon={<ArrowsExpandIcon />}
              color="slate"
            />
            {chatVisible ? <Chat username={userInfo.name} chatRoomURL={chatRoomURL} /> : ""}
            {settingsVisible ? (
              <Settings
                meeting={meeting}
                handleCameraChanged={handleCameraChanged}
                handleMicChanged={handleMicChanged}
                handleSpeakerChanged={handleSpeakerChanged}
              />
            ) : (
              ""
            )}
            {onlineUsersVisible ? (
              <OnlineUsers
                handleMuteUserAudio={handleMuteUserAudio}
                handleMuteUserVideo={handleMuteUserVideo}
                handleBanUser={handleBanUser}
                handleEjectUser={handleEjectUser}
                handleAcceptRequestToJoin={handleAcceptRequestToJoin}
                userInfo={userInfo}
                onlineUsers={onlineUsers}
                meetingAccessRequests={meetingAccessRequests}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      );
    } else if (sidebarPosition === "bottom") {
      // Chat at the bottom
      return (
        <div className="grid grid-cols-1 h-full w-full bg-gray-200 relative">
          <div className="md:col-span-3 sm:col-span-2 ">
            {/* Main Area */}
            <VideoLayoutGrid
              ownerOnlyBroadcast={ownerOnlyBroadcast}
              meeting={meeting}
              localMediaStream={localMediaStream}
              onlineUsers={onlineUsers}
              videoTiles={videoTiles}
              activeSpeakerId={activeSpeakerId}
              mockVideoTags={4}
            />
            {ControlWithArguments}
          </div>

          <div className="bg-red-400 relative">
            <RoundedIconButton
              className="sm:hidden absolute right-0 top-0"
              icon={<ArrowsExpandIcon />}
              color="slate"
            />
            {/* Sidebar */}
            {chatVisible ? <Chat username={userInfo.name} chatRoomURL={chatRoomURL} /> : ""}
            {settingsVisible ? (
              <Settings
                handleCameraChanged={handleCameraChanged}
                handleMicChanged={handleMicChanged}
                handleSpeakerChanged={handleSpeakerChanged}
              />
            ) : (
              ""
            )}
            {onlineUsersVisible ? (
              <OnlineUsers
                handleMuteUserAudio={handleMuteUserAudio}
                handleMuteUserVideo={handleMuteUserVideo}
                handleBanUser={handleBanUser}
                handleEjectUser={handleEjectUser}
                userInfo={userInfo}
                onlineUsers={onlineUsers}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      );
    } else if (sidebarPosition === "left") {
      return (
        <div className="grid grid-cols-1 sm:grid-cols-4 h-full w-full bg-gray-200 relative">
          <div className="md:col-span-1 sm:col-span-2 relative">
            <RoundedIconButton
              className="sm:hidden absolute right-0 top-0"
              icon={<ArrowsExpandIcon />}
              color="slate"
            />
            {/* Sidebar */}
            {chatVisible ? <Chat username={userInfo.name} chatRoomURL={chatRoomURL} /> : ""}
            {settingsVisible ? (
              <Settings
                handleCameraChanged={handleCameraChanged}
                handleMicChanged={handleMicChanged}
                handleSpeakerChanged={handleSpeakerChanged}
              />
            ) : (
              ""
            )}
            {onlineUsersVisible ? (
              <OnlineUsers
                handleMuteUserAudio={handleMuteUserAudio}
                handleMuteUserVideo={handleMuteUserVideo}
                handleBanUser={handleBanUser}
                handleEjectUser={handleEjectUser}
                userInfo={userInfo}
                onlineUsers={onlineUsers}
              />
            ) : (
              ""
            )}
          </div>

          <div className="md:col-span-3 sm:col-span-2 ">
            {/* Main Area */}
            {ControlWithArguments}
          </div>
        </div>
      );
    }
  } else {
    return (
      <div className="grid grid-cols-1 h-full w-full bg-gray-200 relative">
        <div className=" max-h-screen max-w-screen">
          {onlineUsers.length === 1 && showInviteBox ? (
            <Invite url={"https://" + window.location.hostname + window.location.pathname} />
          ) : (
            ""
          )}
          {/* Main Area */}
          <VideoLayoutGrid
            ownerOnlyBroadcast={ownerOnlyBroadcast}
            meeting={meeting}
            localMediaStream={localMediaStream}
            onlineUsers={onlineUsers}
            videoTiles={videoTiles}
            activeSpeakerId={activeSpeakerId}
          />
          {ControlWithArguments}
        </div>
      </div>
    );
  }
}

export default CallLayout;
